module.exports = __webpack_public_path__ + "static/media/facebook_reaction_sorry.143584d1.svg";